export default {
  statistics: {
    servicetype: "サービスタイプ",
    search: "検索",
    exportfile: "エクスポート",
    submit: "提出",
    createdate: "作成日",
    orderno: "注文番号",
    businestype: "業務タイプ",
    payment: "支払金額(保険、サービス料含む)",
    insufee: "保険料",
    servicefee: "サービス料",
    productname: "製品名",
    total: "合計",
    departmentname: "部門名",
    selectdepart: "部門を選択してください",
    costcenter: "コストセンター",
    expenseDepartment: "費用負担部門",
    selectcostcenter: "コストセンターを選択してください",
    selectExpenseDepartment: "費用負担部門を選択してください",
    projectcode: "プロジェクトコード",
    startdate: "開始日",
    enddate: "締切日",
    paytotalmoney: "合計金額",
    avgticketprice: "チケット均等額",
    avgroomfee: "宿泊費均等額",
    avgdiscount: "割引",
    breakbtrip: "ポリシー違反",
    advdayinfo: "事前予約日数状況",
    day: "日",
    departpaysort: "各部門消費ランキング",
    costpaysort: "各コストセンターランキング",
    expenseDepartmentRanking: "各費用負担部門ランキング",
    projectcodepaysort: "各プロジェクトコードランキング",
    arrpaysort: "各目的地ランキング",
    tonglist: "統計リスト",
    tongview: "統計ビュー",
  },
  order: {
    ordertip: "オンラインで過去1年分のご注文を確認できます。それ以前のご注文を確認する必要がある場合は、400-088-8020（長距離通話料無料）までお電話ください。",
    allorder: "すべての注文",
    startdate: "開始日",
    endadte: "終了日",
    orderstatus: "ステータス",
    ordertype: "タイプ",
    searchkey: "商品名または注文番号を入力し、検索",
    search: "検索",
    number: "数",
    orderdetail: "発注情報",
    ordertotalmoney: "発注総額",
    dealoperation: "取引操作",
    submit: "今すぐ提出",
    approval: "今すぐ承認",
    payment: "今すぐ支払い",
    createorder: "再度注文",
    oldsystem: "旧システム",
    rejectReason: "承認備考",
    reapproval: "承認拒否",
    approvalsucc: "承認",
    selectvoy: "キャンセル必要なフライトを選択してください！",
    selectpass: "キャンセル必要な乗客を選択してください！",
    selectreason: "キャンセルの理由を選択してください！",
    amendsucc: "キャンセル申請提出済み",
    flightchange: "航空券変更",
    selectchangepass: "渡航者を選択してください！",
    oldvoyageinfo: "元のフライト情報",
    selectedflight: "選択済みフライト",
    policyok: "ルール適用",
    policyno: "ルール違反",
    build: "空港使用料",
    fuel: "燃油サーチャージ",
    changeflight: "フライト変更",
    flightlist: "フライトリスト",
    changefee: "変更手数料",
    changefeetip: "以下の費用は参考値です。ご不明な点がございましたら、カスタマーサービスまでお電話ください。",
    changefeeabout: "変更手数料見込み（変更予約）",
    upcabinfeeabout: "アップグレード料金見込み",
    changeservicefee: "変更手数料",
    totalfee: "合計",
    changereason: "変更申請理由を入力してください",
    changedetreason: "変更の詳細理由を入力してください（任意）",
    back: "<<戻る",
    submitapply: "申請を送信",
    flightsearchfail: "条件に合致するフライト情報が見つかりませんでした！",
    flightchangereason: "変更理由を選択してください",
    losesource: "フライト情報をご確認ください",
    flightchangesucc: "変更申請が送信されました！",
    orderdetail: "注文情報",
    voyageinfo: "旅程情報",
    flightpass: "渡航者",
    contactpeople: "連絡先",
    costcenter: "コストセンター",
    expenseDepartment: "費用負担部門",
    policynoreason: "ポリシー違反の理由",
    demandremark: "備考",
    fujianxinxi: "添付情報",
    btripinfo: "ビジネス旅行情報",
    procode: "プロジェクトコード",
    btripaim: "出張目的",
    btripMatter: "出張理由",
    approvalstatus: "承認ステータス",
    violate: "違反しました",
    policydetail: "のポリシー",
    vioreason: "違反理由",
    reasondetail: "詳細理由",
    order: "注文",
    bookingdate: "予約日",
    orderid: "注文番号",
    oldorderid: "元の注文番号",
    bookingway: "予約方法",
    paymentway: "支払い方法",
    totalmoney: "合計金額",
    submitorder: "注文を送信",
    cancelorder: "注文をキャンセル",
    ordervoyage: "旅程",
    realtake: "実際利用",
    share: "共有",
    orderchange: "変更したい",
    orderamend: "キャンセルしたい",
    departcity: "出発先",
    arrivecity: "到着先",
    departdate: "チェックアウト",
    arrivedate: "チェックイン",
    hotelname: "ホテル名",
    hotelphone: "ホテル電話番号",
    hoteladdress: "ホテル住所",
    roomtype: "部屋タイプ",
    cityname: "都市名",
    startstation: "出発駅",
    endstation: "到着駅",
    seattype: "座席タイプ",
    tourpeople: "渡航者",
    sequence: "番号",
    name: "氏名",
    cardno: "旅券番号",
    birthday: "生年月日",
    phoneno: "携帯電話番号",
    invoiceinfo: "証憑情報",
    invoiceid: "証憑コード",
    passname: "渡航者名",
    invoiceno: "証憑番号",
    seatno: "座席番号",
    tradeinfo: "取引情報",
    tradepeople: "取引人",
    tradeway: "取引方法",
    tradetype: "取引タイプ",
    trademoney: "取引金額",
    createtime: "作成日時",
    email: "メールアドレス",
    phone: "携帯",
    applyamend: "払い戻し申請",
    selectordervoyage: "旅程を選択",
    selectorderpass: "旅客を選択",
    selectorderreason: "理由を選択",
    cancel: "キャンセル",
    changeapply: "変更申請",
    adultticket: "大人用",
    amendfee: "キャンセル料",
    samechangefee: "同クラス変更手数料",
    changecondition: "変更条件",
    changeadopt: "変更可",
    people: "人",
    completechange: "変更済み",
    reimburseinfo: "経費精算情報",
    travleorderinfo: "全額分の旅程表を提供可能",
    bagkg: "手荷物許容量",
    forfeebagkg: "無料受託手荷物許容量20KG",
    loading: "読み込み中......",
    endststion: "到着駅",
    waitapprove: "承認待ち",
    changeamendrule: "払戻・変更規則",
    trainamendrule:
      "出発8日前（含まない）までの払戻には、払戻手数料はかかりません。乗車駅出発時刻の48時間前までの払戻には、運賃の5%の払戻手数料がかかります。出発24時間前から48時間前までの払戻には、運賃の10%の払戻手数料がかかります。出発24時間前を切った払戻には、運賃の20%の払戻手数料がかかります。",
    touramendrule: "締結された契約を基準とします",
    selectPassengersChange: "変更する旅客を選択してください",
    fillFlight: "フライト情報を入力",
    depart: "出発",
    arrive: "到着",
    date: "日付",
    dueTo: "予約日",
    for: "～に",
    ChangeTo: "変更日",
    WasteBack: "払戻・廃票日",
    ExpectedRefundFee: "払戻手数料（見込み）",
    reasonRejection: "拒否理由を入力してください",
    ordeCancel: "注文キャンセル",
    isCancel: "注文をキャンセルしてもよろしいですか",
    confirm: "確認",
    BusinessType: "業務タイプ",
  },
  system: {
    clear: "クリア",
    combtripmemberlogin: "企業ビジネス旅行会員ログイン",
    lchbtrip: "力程商旅",
    simple: "シンプルであればあるほど",
    free: "自由であればあるほど",
    lowermoney: "さらにお得に",
    prebtrip: "完璧な出張サービス",
    unyouneed: "お客様のニーズを理解する",
    servicenotime: "時差のない総合サービス",
    costcenlower: "出張コストを30%削減",
    peoplecenter: "マイページ",
    ri: "日",
    trtavleregtips: "金額が0の場合は金額制限なし、航空券の座席クラスと鉄道の座席がチェックされている場合は利用可能",
    firstcity: "一級都市",
    seccity: "二級都市",
    thrcity: "三級都市",
    none: "なし",
    allmoney: "定価",
    discountdown: "割引以下",
    deletefiletips: "削除操作を実行してもよろしいですか？",
    tips: "ヒント",
    cancel: "キャンセル",
    usericon: "アバター",
    uploadusericon: "アバターアップロード",
    changusericon: "アバター変更",
    bangemail: "メールアドレスを紐付け",
    bangphone: "携帯電話番号をバインド",
    orderid: "注文番号",
    ordervoyageinfo: "旅程情報",
    bookingdate: "予約日",
    orderstatus: "注文ステータス",
    bookinguser: "予約者",
    btriprule: "出張規定",
    btripaim: "出張目的",
    policyreason: "ポリシー上の理由",
    bookinginfo: "予約注意事項",
    btripflow: "出張承認",
    search: "検索",
    add: "追加",
    name: "名称",
    number: "番号",
    servicetype: "サービスタイプ",
    chinese: "中国語",
    english: "英語",
    operation: "操作",
    copy: "コピー",
    update: "修正",
    delete: "削除",
    delsucc: "削除成功",
    inputcontent: "内容を入力してください",
    selectcustomers: "顧客を選択",
    zhdescribe: "中国語説明",
    rule: "ルール",
    ruleid: "ルール番号",
    rulename: "ルール名",
    travelregulations: "出張管理ルール",
    endescribe: "英語説明",
    btripflowname: "出張承認名",
    btripflowrule: "出張承認ルール",
    selectbtriprule: "出張ルールを選択",
    selectbtripflow: "承認フローを選択",
    needflow: "出張承認設定",
    roleapplybtrip: "ルール適用ロール",
    departrole: "部門ロール",
    jobrole: "役職ロール",
    employeeandcustomer: "従業員マイレージ会員",
    btripflowid: "出張承認番号",
    btriprulename: "出張ルール名",
    approvalfloename: "承認フロー名",
    flowid: "フロー番号",
    back: "<< 戻る",
    save: "保存",
    savesucc: "保存成功",
    operlogs: "操作ログ",
    addsucc: "追加成功",
    updatesucc: "変更成功",
    businessname: "企業名",
    businessmanage: "企業管理",
    servicemanage: "サービス管理",
    reportsmanage: "レポート管理",
    pleaseselect: "選択してください",
    pleasewrite: "入力してください",
    companyinfo: "基本情報",
    companyname: "会社名",
    city: "都市",
    profession: "業界",
    contactname: "連絡先担当者名",
    selectcycle: "期間を選択してください",
    selectdate: "日付を選択してください",
    selecttrade: "取引を選択してください",
    phonenoerror: "携帯電話番号の形式が正しくありません",
    emailerror: "郵便番号の形式が正しくありません",
    contactnameerror: "受取人名は必須です",
    deliverymanage: "配送管理",
    addcontact: "新しい住所を追加",
    contactpeople: "受取人",
    address: "詳細住所",
    remark: "備考",
    postcode: "郵便番号",
    contactphone: "連絡先携帯電話",
    contactnickname: "住所略称",
    contactemail: "連絡先メールアドレス",
    defaultaddress: "デフォルト住所",
    setdefaultaddress: "デフォルトに設定",
    addressinfo: "住所情報",
    peoplemanage: "個人管理",
    lasterorder: "最近の注文",
    voyagesdate: "旅程カレンダー",
    voyagesremark: "旅程備考",
    welcomelogin: "ログインを歓迎",
    login: "ログイン",
    registernow: "企業登録",
    register: "登録",
    loginbyaccount: "アカウントパスワードログイン",
    loginbyphone: "携帯動的コードログイン",
    loginbyother: "以下の方法でもログインできます",
    wechat: "微信",
    pleaseinputvalcode: "認証コードを入力してください",
    loginredittips: "秒後にホームページに移動します......",
    accountinfo: "アカウント情報",
    peopleregister: "個人ユーザー",
    companyregister: "企業顧客登録",
    kefucenter: "カスタマーセンター",
    loginout: "ログアウト",
    account: "アカウント",
    pwd: "パスワード",
    pwdtips: "パスワードを入力してください",
    forgetpassword: "パスワードをお忘れですか?",
    saveloginstats: "ログイン状態を記憶する",
    accounttips: "携帯電話番号またはメールアドレスを入力してください",
    password: "ログインパスワード",
    passwordtips: "8～16桁を入力してください",
    passwordfirstlevel: "弱",
    passwordfirstleveltips: "英字と数字を含む",
    passwordsecleveltips: "英字、数字、特殊記号を含む",
    passwordseclevel: "中",
    passwordlastleveltips: "大文字と小文字の英字、数字、特殊記号を含む",
    passwordlastlevel: "強",
    confirmpassword: "パスワード確認",
    validecode: "認証コード",
    validecodeignorecase: "大文字と小文字を区別しない",
    changevalidecode: "別の画像に変更",
    dynavalidecode: "動的認証コード",
    dynavalidecodetips: "動的認証コードを入力してください",
    loginedregistertips: "力程商旅アカウントにログインしています。個人アカウントを登録するには、まずログアウトしてください！",
    agreeprotocol: "「サービス利用規約」に同意する",
    reset: "リセット",
    registeproblem: "登録で問題が発生しましたか？",
    inputpwdagain: "パスワードをもう一度入力してください",
    notsamepwd: "2回入力したパスワードが一致しません！",
    emailaccounttips: "メール認証コードを送信",
    phoneaccounttips: "SMS認証コードを送信",
    sendvalidecode: "認証コードを送信",
    registersucc: "登録成功",
    registersucctips: "登録に成功しました。ログインしてください",
    companyaccounttips: "このアカウントは既に企業アカウントです。企業アカウントを登録するには、ログアウトして再度登録してください。",
    codesendtips: "送信済み",
    codeagain: "認証コードを取得",
    resetaccountback: "前のステップに戻る",
    resetaccountfirst: "アカウントを入力",
    resetaccountsec: "本人確認",
    resetaccountthr: "新しいパスワードを設定",
    resetaccountlast: "完了",
    submit: "提出",
    resetphoneaccounttips: "有効な登録済み携帯電話番号でログインパスワードをリセットできます。",
    resetaccountbyphone: "携帯電話認証でリセット",
    resetemailaccounttips: "有効な登録済みメールアドレスでログインパスワードをリセットできます。",
    resetaccountbyemail: "メール認証でリセット",
    resetpwdbyvalide: "ログインパスワードのリセットを確認",
    sendresetpwdcodetips: "力程網は、ご登録の（携帯電話またはメールアドレス）に認証コードを送信しました。ご確認の上、認証コードを入力してください。",
    resetpwdcodename: "受信した認証コード",
    confirm: "確定",
    invoiceinfo: "証憑情報",
    yes: "はい",
    no: "いいえ",
    invoicemanage: "請求書管理",
    invoicerole: "請求書ロール",
    invoicetype: "請求書の種類",
    invoicename: "請求書の宛名",
    identifynumber: "納税者識別番号",
    invoicebankname: "口座開設銀行名",
    invoicebankaccount: "口座開設銀行口座番号",
    invoicecompanyadsress: "登録住所",
    invoicecompanyphone: "登録電話番号",
    invoicelistlefttitle: "保存済み",
    invoicelistrighttitle: "件の住所",
    updatedate: "データを変更",
    invoicetypetips: "請求書の種類を選択してください",
    invoicenametips: "請求書の宛名を入力してください",
    identifynumbertips: "納税者識別番号を入力してください",
    invoicebanknametips: "口座開設銀行名を入力してください",
    invoicebankaccounttips: "口座開設銀行口座番号を入力してください",
    invoicecompanyadsresstips: "登録住所を入力してください",
    invoicecompanyphonetips: "登録電話番号を入力してください",
    messagetemplatelist: "SMSテンプレート一覧",
    messagename: "SMS名",
    messagetype: "SMSの種類",
    messagetemplatename: "SMSテンプレート名",
    messagetemplatetype: "SMSテンプレートタイプ",
    messagetemplatecontent: "SMSテンプレート内容",
    updateuser: "更新者",
    disables: "無効",
    enable: "有効",
    managesetting: "管理設定",
    messagetemplatestatus: "ステータス",
    addmessagetemplate: "SMSテンプレート編集",
    username: "氏名",
    cardno: "身分証明書番号",
    cardvaliditydate: "有効期限",
    cardincountry: "発行機関",
    cardimg: "証明書画像",
    reproveimg: "表面画像",
    deleteimg: "画像を削除",
    reverseimg: "裏面画像",
    uploadimg: "画像をアップロード",
    companyinfo: "基本情報",
    cardinfo: "証明書情報",
    contactinfo: "連絡先情報",
    customermanage: "カスタマーマネージャー",
    companynickname: "会社略称",
    englishcompanyname: "英語名",
    companyemail: "会社メールアドレス",
    companyaddress: "会社住所",
    companytype: "会社種別",
    capitaltype: "資本タイプ",
    companysize: "会社規模",
    companyprofession: "業種",
    companyremark: "備考情報",
    rolecontactpeople: "連絡先",
    rolecontactpeoplename: "連絡先担当者名",
    importcontact: "住所インポート",
    phoneareacode: "携帯電話の市外局番",
    contactaddress: "連絡先住所",
    province: "省",
    district: "県・区",
    changecompanypeopletips: "注意：引継ぎ担当者が会社の権限を受け取った後、あなたは管理者権限を失います",
    companypeople: "引継ぎ担当者",
    regularcard: "常連カード",
    regularcardno: "カード番号",
    disclaimer: "免責事項",
    fullname: "正式名称",
    nickname: "略称",
    sex: "性別",
    country: "国籍",
    charge: "管理者",
    selectcharge: "管理者を選択",
    companyorgan: "組織構造",
    actionupdatetips: "権限を設定する必要がない場合は、「保存」をクリックして次の設定に進んでください。",
    roleaction: "ロール権限",
    allemployee: "全従業員",
    roleemployee: "所属従業員",
    roleemployeetips: "この従業員は既に現在の部門に所属しています",
    setmanage: "構成管理",
    workcity: "勤務都市",
    workjob: "職務",
    workname: "通称名",
    worktime: "勤務時間",
    workdatarang: "表示範囲",
    birthday: "生年月日",
    list: "リスト",
    createtime: "作成日時",
    startdate: "開始日",
    enddate: "終了日",
    sequence: "番号",
    supername: "上位名称",
    updatetime: "変更日",
    detail: "詳細",
    setting: "設定",
    serviceinfo: "サービス情報",
    servicename: "サービス名",
    publishname: "リリース名",
    applyarea: "適用エリア",
    servicepublic: "公開するかどうか",
    publishservice: "サービスを公開",
    publishedservice: "サービスは公開済み",
    advancetime: "事前予約時間",
    workperiod: "周期",
    publishsave: "公開を確認",
    servicefarelist: "サービス料リスト",
    servicefarename: "サービス料名",
    servicefareid: "サービス料番号",
    companyid: "会社番号",
    servicefarestatus: "サービス料ステータス",
    policystatus: "ポリシーステータス",
    customername: "顧客名",
    bookingway: "予約方法",
    workingtime: "勤務時間",
    servicefarebyworkingtime: "勤務時間に基づいて計算するかどうか",
    money: "元",
    other: "その他",
    fare: "費用",
    roles: "役割",
    jobs: "職位",
    departments: "部門",
    companys: "会社",
    customers: "レベル",
    role: "役割",
    job: "職位",
    employee: "従業員",
    user: "ユーザー",
    guest: "常連客",
    customer: "顧客",
    costcenters: "コストセンター",
    expenseDepartments: "費用負担部門",
    flowid: "フロー番号",
    flowname: "プロセス名",
    flowmanage: "プロセス管理",
    dealpeople: "処理担当者",
    up: "上へ移動",
    down: "下へ移動",
    langsetting: "言語設定",
    english: "英語",
    japan: "日本語",
    china: "中国語",
    opened: "開通済み",
    closed: "未開通",
    expired: "期限切れ",
    disable: "禁止済み",
    systemsafe: "セキュリティ設定",
    downloadtemplate: "テンプレートをダウンロード",
    PermissionEmployees: "権限従業員",
    GrantDate: "付与日",
    ExpirationDate: "有効期限",
    saveInfo: "情報を保存",
    approvalList: "承認リスト",
    StaffName: "従業員名",
    detail: "詳細",
    CompanyPage: "会社ホームページ",
    selectCityAgain: "都市を再選択してください",
    ChooseShipCompany: "航空会社を選択",
    FutureGenerations: "すべて選択",
    TheSelected: "選択を反転",
    QuickFindSelection: "クイック検索選択：ここで複数の航空会社を入力できます。/で区切り、Ctrl+Enterキーで選択します",
    shipCompany: "適用航空会社",
    shipSpace: "クラスを選択",
    applySpace: "適用クラス",
    AsOfTheDate: "締切日",
    AddLevel: "レベル追加",
    LevelNames: "レベル名",
    LevelCode: "レベルコード",
    RetentionSet: "留保設定と顧客設定",
    LeaveSome: "ポイント留保",
    keepMoney: "金額留保",
    ServiceLevelAdd: "サービスレベル追加",
    ProductCategory: "製品カテゴリ",
    SubscribeCustomer: "サブスクリプション顧客",
    SaveButtonSet: "留保設定",
    localChineseName: "地域の中国語名を入力してください",
    localEnglishName: "地域の英語名を入力してください",
    PreviewPicture: "画像プレビュー",
    keywordsFilter: "キーワードを入力してフィルタリング",
    DataIntegrity: "資料の完全度",
    PerfectInformation: "資料を充実させる",
    AuthorizationState: "認証状態",
    accountNumber: "アカウントを入力してください",
    DynamicCode: "動的コード",
    congratulations: "おめでとうございます",
    ClickNoResponse: "力程商旅プラットフォームに移動しています。6秒以内に反応がない場合は、クリックしてください",
    Here: "こちら",
    PasswordChangedSucc: "パスワードの変更に成功しました",
    selectParentDirectory: "上位ディレクトリを選択してください",
  },
  mall: {
    one: "一",
    two: "二",
    three: "三",
    four: "四",
    five: "五",
    six: "六",
    seven: "七",
    eight: "八",
    nine: "九",
    ten: "十",
    contactUs: "お問い合わせ",
    adequateTxt: "十分",
    sheet: "枚",
    Remaining: "残りわずか",
    ReElectionFlight: "フライトを再選択",
    TaxExclusive: "税抜き",
    notificationMessageFlight:
      "通知：必要に応じて、こちらをクリックして国際リクエストシートにアクセスすると、より多くのより安い国際航空券をご利用いただけます。あらゆる出張ニーズに対応するため、お電話でも承ります：",
    Hotline: "ホットラインでお問い合わせください。",
    EnfantYears: "2～14歳",
    InfantYears: "2歳未満",
    budget: "予算",
    Mylicheng: "マイ旅程",
    SupportChinese: "中国語/ピンイン/略称入力対応",
    SupportCode: "中国語/ピンイン/略称/都市コード入力対応",
    hotCity: "人気都市",
    attendance: "参加人数",
    hostPlace: "開催場所",
    activityBudget: "イベント予算",
    PartyNumber: "参加人数",
    internationalHotel: "国際ホテルリクエストシート",
    pay: "支払う",
    NextPage: "次のページ",
    PreviousPage: "前のページ",
    selected: "選択済み",
    data: "データ",
    strip: "条",
    paginal: "ページごと",
    page: "ページ",
    AuxiliaryWord: "第",
    searchName: "名称を入力して検索（右側のボタンをクリックして臨時ゲストとして追加可能）",
    keywordsPlaceholder: "キーワードを入力して検索",
    selectName: "選択した名称",
    Station: "経由駅",
    TotalAmount: "支払総額",
    checkIn: "チェックイン",
    Broadband: "ブロードバンド",
    AttentionPlease: "（特別注意：審査を通過しやすくするため、違反理由を記入してください）",
    TripAgainst: "行程が違反しました",
    DetailReason: "詳細理由",
    ContraryReason: "違反理由",
    Sex: "旅客性別",
    Nationality: "国籍",
    Birthdate: "生年月日",
    Mobile: "連絡先番号",
    ID: "証明書情報",
    PassengerName: "旅客氏名",
    Policy: "出張規定",
    price: "価格",
    BedType: "ベッドタイプ",
    Window: "窓タイプ",
    ViewsMore: "もっと見る",
    durationTime: "所要時間",
    flightInfo: "フライト情報",
    next: "次へ",
    destination: "目的地",
    NoTrainSearch: "現在の時間帯は列車検索サービスを提供していません",
    selectedconsumer: "選択済み旅客",
    btripflow: "出張承認",
    bookingcenter: "予約センター",
    demandorder: "需要オーダー",
    selectcompany: "会社選択",
    costcenter: "コストセンター",
    expenseDepartment: "費用負担部門",
    approvalpolicy: "承認ポリシー",
    bookinguser: "従業員予約",
    pleaseselect: "選択してください",
    bookingsearch: "予約照会",
    btripaim: "出張目的",
    budgetCode: "予算コード",
    budgetIntro: "予算説明",
    projectcode: "プロジェクトコード",
    bookingtype: "公用・私用",
    applyarea: "適用エリア",
    serviceset: "サービス料設定",
    flowinfo: "承認フロー",
    name: "名称",
    flowname: "承認者情報",
    btriprule: "出張規定",
    priority: "プロトコル優先",
    pricelimit: "価格制限",
    bookinginfo: "予約注意事項",
    zhtips: "中国語のヒント",
    entips: "英語のヒント",
    updateorder: "注文を変更する",
    submitorder: "注文を送信",
    tourpasstips: "旅行注文はこの乗客タイプをサポートしていません",
    createsucc: "注文が正常に作成されました",
    orderapprovalsucc: "注文の審査が成功しました",
    pnr: "コードインポート",
    flightno: "便名",
    flightdate: "フライト日付",
    airportinfo: "空港情報",
    cabin: "座席クラス",
    realflight: "実際の運送",
    depairportcode: "出発空港の3レターコード",
    arrairportcode: "到着空港の3レターコード",
    hotelname: "ホテル名",
    hotelphone: "ホテル電話番号",
    hoteladdress: "ホテル住所",
    hotelarrivedate: "チェックイン日",
    hoteldepartdate: "出発日",
    hotelamenddate: "チェックアウト日",
    roomnum: "部屋数",
    roomtype: "部屋タイプ",
    roombedtype: "部屋のベッドタイプ",
    breakfast: "朝食",
    consumerDate: "チェックイン時間",
    finishedDate: "チェックアウト時間",
    changeamendrule: "払戻・変更規則",
    aimcity: "目的地の都市",
    selectdate: "日付を選択",
    keywords: "キーワード",
    hotelkeywords: "(オプション)ホテル名/ランドマーク/商業エリア",
    search: "検索",
    qi: "から",
    searchdetail: "詳細を見る",
    notReserve: "予約可能な部屋タイプはありません",
    traffmap: "交通地図",
    sheetzone: "周辺のストリートビュー",
    btripno: "ルールに違反",
    btripyes: "ルールに合致",
    room: "部屋",
    spec: "平方メートル",
    live: "宿泊可能人数",
    floor: "階数",
    layer: "階",
    productname: "製品名",
    averagerate: "日平均価格",
    breakfastInfos: "食事情報",
    breakfastyes: "朝食付き",
    breakfastno: "朝食なし",
    cancelno: "キャンセル不可",
    timecancel: "期間限定キャンセル",
    plenty: "十分",
    select: "選択",
    hotelfacilities: "ホテル施設",
    wifi: "有料Wi-Fi",
    none: "なし",
    parking: "駐車場",
    allfacilities: "一般施設",
    activefacilities: "アクティビティ施設",
    serviceproject: "サービス項目",
    hotelpolicy: "ホテルポリシー",
    depandarr: "チェックイン/チェックアウト",
    chdpolicy: "お子様ポリシー",
    mealment: "お食事の手配",
    apartment: "アパートメント",
    theinn: "民宿",
    familyhotel: "ファミリーゲストハウス",
    youthhostel: "ユースホステル",
    coupleshotel: "カップルホテル",
    gardencourtyard: "庭園付きホテル",
    seaview: "海の景色",
    generated: "農家楽",
    hotspringshotel: "温泉ホテル",
    golfhotel: "ゴルフホテル",
    siheyuan: "四合院",
    villa: "別荘",
    cookingdinnerparty: "パーティー料理",
    businesstriphome: "ビジネス旅行の家",
    recreationalfeeling: "リラックスした雰囲気",
    hospital: "診察・治療",
    holidayleisure: "休暇・レジャー",
    traininglearn: "研修・学習",
    party: "パーティー",
    honeymoontrip: "ハネムーン旅行",
    boutiquehotel: "ブティックホテル",
    indoorswimmingpool: "屋内プール",
    outdoorswimmingpool: "屋外プール",
    gym: "ジム",
    businesscenter: "ビジネスセンター",
    meetingroom: "会議室",
    hotelrestaurant: "ホテルレストラン",
    wakeupcall: "モーニングコール",
    luggage: "手荷物預かり",
    doublebed: "ツインベッド",
    bigbed: "ダブルベッド",
    pickupservice: "送迎サービス",
    pet: "ペット",
    creditcard: "クレジットカード",
    username: "氏名",
    usersex: "性別",
    PassengerType: "旅行者タイプ",
    cardtype: "身分証明書の種類",
    cardno: "身分証明書番号",
    contactphone: "連絡先携帯電話",
    birthday: "生年月日",
    usercountry: "国籍",
    cardvaliditydate: "身分証明書の有効期限",
    add: "追加",
    delete: "削除",
    passselect: "旅客を選択",
    contactpeople: "連絡先氏名",
    contactemail: "連絡先メールアドレス",
    salesprice: "販売価格",
    marketprice: "市場価格",
    supplyprice: "決済価格",
    tourdepcity: "出発地",
    tourarrcity: "目的地",
    teamno: "団体番号",
    tourdepdate: "旅行日",
    remark: "備考",
    traininfo: "列車情報",
    trainno: "列車番号",
    trainseattype: "座席クラス",
    traindepdatetime: "出発時間",
    trainarrdatetime: "到着時間",
    traindepdate: "出発日",
    amendtime: "変更・キャンセル期限",
    moneysourceairway: "航空会社の最新規定に準じます。カスタマーサービスまでお問い合わせください。",
    amendruletips: "上記の大人変更・キャンセル規則及び料金基準は参考用であり、実際は航空会社の規定に準じます。",
    adultticket: "大人券",
    amendfee: "払戻手数料",
    samechangefee: "同クラス変更手数料",
    changecondition: "変更条件",
    changeadopt: "変更許可",
    people: "人",
    completechange: "変更完了",
    reimburseinfo: "経費精算情報",
    travleorderinfo: "全額分の旅程表を提供可能",
    travleinvoince: "差額領収書と旅程表を提供します。",
    bagkg: "手荷物許容量",
    forfeebagkg: "無料受託手荷物許容量20KG",
    realtake: "実際の乗車",
    realtaketips: "実際に搭乗する便でチェックインを行ってください。",
    share: "共有",
    airplanemodel: "機種",
    isstop: "経由",
    allprice: "定価",
    discount: "割引",
    protocolprice: "ビジネスおすすめ",
    build: "空港使用料",
    fuel: "燃油サーチャージ",
    booking: "予約",
    flightok: "確定",
    allprices: "その他の料金",
    flightnum: "枚",
    flightnumtips: "残りわずか",
    flightgo: "往路",
    flightback: "復路",
    flightdetail: "フライト詳細",
    totalmoney: "合計金額",
    flightticket: "国内航空券",
    iflightticket: "国際航空券",
    screening: "絞り込み条件",
    clear: "クリア",
    flightvuelo: "直行便/乗り継ぎ",
    flightdeptimes: "出発時間帯",
    airways: "航空会社",
    depairport: "出発空港",
    arriveairport: "到着空港",
    checkflightgo: "選択済み往路",
    changeflight: "フライト変更",
    flightlisttips: "件のフライト情報",
    flightdeptime: "出発時間",
    flightarrtime: "到着時間",
    flightprice: "価格",
    nostop: "直行便",
    transfer: "{city}経由（待ち時間：{time}）",
    TransferVoyage: "乗り継ぎ",
    NostopOrTransfer: "直行便/乗り継ぎ",
    ShareFlight: "コードシェア便",
    HideShareFlight: "コードシェア便を非表示",
    am: "午前",
    noon: "正午",
    pm: "午後",
    firstcabin: "ファーストクラス",
    businesscabin: "ビジネスクラス",
    economycabin: "エコノミークラス",
    createflightorder: "確認、次へ",
    loading: "読み込み中......",
    flightpricechange: "航空券の価格が変更されました。確認後にご注文ください！",
    tips: "ヒント",
    confirm: "確認",
    flightbookingtitel: "マイ旅程",
    flightbooking: "航空券の予約",
    orderdetail: "注文情報",
    contactinfo: "連絡先情報",
    taketicketway: "チケット受取方法",
    departcity: "出発都市",
    arrivecity: "到着都市",
    departdate: "出発時間",
    arrivedate: "到着時間",
    backdate: "帰りの時間",
    loginuser: "現在のユーザー",
    priceway: "見積もり方法",
    pricestips: "このページで提供される航空券はネット価格であり、サービス料は含まれておりません。",
    firtransfer: "1回乗り継ぎ",
    sectransfer: "2回以上の乗り継ぎ",
    transfercitys: "乗り継ぎ都市",
    economy: "エコノミークラス",
    business: "ビジネスクラス",
    first: "ファーストクラス",
    premiumecon: "プレミアムエコノミークラス",
    premiumebus: "プレミアムビジネスクラス",
    premiumefirst: "プレミアムファーストクラス",
    iflightcitytips: "国際都市を選択してください！",
    approvalSelectCitytips: "出発地と到着地のいずれかが、承認された旅程に含まれている必要があります！",
    approvalDepartDatetips: "出発日は承認書の日付範囲に準拠する必要があります！",
    approvalArriveDatetips: "出発/帰着日は承認書の日付範囲に準拠する必要があります！",
    approvalSelectHotelCitytips: "目的都市は承認書の旅程に属している必要があります！",
    iflightbookingtips: "選択されたフライトの航空券は残り",
    policyyes: "ルールに合致",
    policyno: "ルールに違反",
    priceandtax: "税込",
    stoptime: "経由時間",
    hotel: "ホテル",
    hotelpeoplenum: "宿泊人数",
    hoteldeskphone: "フロント電話番号",
    hotelleveltitle: "星評価を高い順に並べ替え",
    hotelpricetitle: "価格を高い順に並べ替え",
    below: "以下",
    above: "以上",
    hotelstart: "二つ星以下",
    threehotelstart: "三つ星/快適",
    fourhotelstart: "四つ星/高級",
    fivehotelstart: "五つ星/ラグジュアリー",
    position: "位置",
    nolimit: "制限なし",
    adminregion: "行政区",
    businesszone: "商業地区",
    startlevel: "星ランク",
    contractHotel: "提携ホテル",
    huazhuHotel: "華住酒店",
    feature: "特色",
    facilities: "施設",
    service: "サービス",
    hotelcounttips: "軒のホテル",
    hotelcountall: "合計",
    hotelinfoorstart: "ホテル情報/星ランク",
    hotelinfo: "ホテル情報",
    referprice: "参考価格",
    reselect: "再選択",
    chinahotel: "国内ホテル",
    interhotel: "国際ホテル",
    bookinghotel: "ホテル予約",
    hotelbookinginfo: "予約情報",
    depandarrdate: "チェックイン/チェックアウト日",
    night: "泊",
    insure: "保険",
    hotelroomtype: "部屋タイプ",
    hotelproductcount: "その他の商品",
    chinatrain: "国内列車",
    trainbooking: "列車の予約",
    trainusernametip: "名前は必須です",
    trainusercardtip: "身分証明書情報を入力してください",
    trainrecard: "身分証番号が重複しています",
    trainseatin: "予約成功、座席確保中",
    selectseatfree: "無料座席指定",
    selectedseat: "座席指定済み",
    noselectseat: "座席未指定",
    trainwindow: "窓側",
    aisie: "通路側",
    trainseattips: "指定座席での発券を優先しますが、指定座席に空きがない場合は、他の座席に変更されます",
    change: "乗換",
    timelength: "所要時間",
    trainticketnum: "残席数",
    trainchangamendinfo: "払戻・変更について",
    traindepandarrstation: "出発/到着駅",
    traindepandarrtime: "出発/到着時間",
    trainlogin12306tip: "12306アカウントと連携し、鉄道公式システムに直接接続することで、より迅速に発券できます！",
    login: "ログイン",
    account: "アカウント",
    login12306user: "12306ユーザー名",
    login12306pwd: "パスワードを入力してください",
    loginerror: "ユーザー名またはパスワードが間違っています",
    loginout: "ログアウト",
    logintip: "ログイン済み",
    btripinfo: "ビジネス旅行情報",
    shenpipingzheng: "承認証憑",
    youshenpipingzheng: "承認証憑あり",
    wushenpipingzheng: "承認証憑なし",
    shenpizhuangtai: "承認ステータス",
    chuchaishenqingiworkyishenpi: "出張申請Iworker承認済み",
    shangweishenpi: "未承認",
    shenpidanhao: "承認番号",
    yijishenpi: "段階承認",
    shangchuanfujian: "添付ファイルをアップロード",
    fujianliebiao: "添付ファイル一覧",
    inputcontent: "内容を入力してください",
    btripordertip: "以下の旅程は出張ポリシーに違反しているため、違反理由を補足する必要があります",
    btriporderttip: "（特別注意：審査を通過しやすくするため、違反理由を記入してください）",
    ordervoyage: "旅程",
    violate: "違反しました",
    policydetail: "のポリシー",
    policynoreason: "ポリシー違反の理由",
    policyreasondetail: "詳細な違反理由",
    consumerinfo: "旅客情報",
    consumernametip: "氏名、搭乗証明書と一致させてください",
    phoneareano: "中国本土の市外局番",
    phonenotips: "搭乗者の携帯電話番号、フライト情報の受信用",
    saveconsumer: "常連客として保存",
    selectconsumer: "乗客を選択",
    addconsumer: "乗客を追加",
    consumertip:
      "重要なお知らせ：旅行を確実にするため、証明書番号と有効期限を正確にご記入ください。旅行終了日は証明書の有効期限より少なくとも6ヶ月以上前である必要があります。",
    writeinfomation: "記入説明",
    demandremark: "リクエスト備考",
    welcomelogin: "ログインを歓迎",
    registernow: "企業登録",
    loginbyaccount: "アカウントパスワードログイン",
    loginbyphone: "携帯動的コードログイン",
    loginbyother: "以下の方法でもログインできます",
    wechat: "微信",
    addressinfo: "住所情報",
    Add: "追加",
    defaultcontact: "デフォルト住所",
    settingdefaultcontact: "デフォルト住所に設定",
    edit: "編集",
    contactpeople: "連絡者名",
    contactphone: "連絡用携帯電話",
    contactemail: "連絡用メール",
    adddemand: "リクエスト入力",
    voyagetype: "フライトタイプ",
    consumertype: "乗客タイプ",
    adult: "大人",
    child: "子供",
    infant: "幼児",
    firstflightsearchtips: "乗客総数（幼児を除く）が9名を超える場合は、ご記入ください",
    flightdemandorder: "航空券リクエストシート",
    lastflightsearchtips: "予約を行います。",
    firstiflightsearchtips: "大人1名につき、最大2名の子供と1名の幼児を同伴できます。特別なご要望がある場合は、こちらまで",
    adminregionhotel: "香港・マカオ・台湾",
    unsubmit: "未提出",
    submited: "提出済み",
    chenking: "審査中",
    paymoney: "支払い済み",
    etdzticket: "発券済み",
    directclose: "成約",
    searchtrainbytraintype: "高速鉄道・新幹線のみ検索",
    selectfrequent: "常連客を選択",
    frequent: "常連客",
    addtemporaryconsumer: "臨時列車を追加",
    home: "ホーム",
    tour: "旅行",
    train: "鉄道",
    flight: "航空券",
    car: "レンタカー",
    food: "グルメ",
    btripplateform: "出張プラットフォーム",
    comcoop: "企業提携",
    appdownload: "アプリダウンロード",
    meeting: "展示会",
    visa: "ビザ",
    tourism: "会議旅行",
    stationname: "駅名",
    trainstoptime: "滞在時間",
    stopstationname: "経由駅",
    soldout: "売り切れ",
    start: "始発",
    over: "経由",
    end: "終点",
    yu: "残り",
    trainbatch: "車両タイプ",
    startorvoer: "始発経由",
    startstation: "出発駅",
    endstation: "到着駅",
    changeticket: "乗車券変更",
    pleasepasstochange: "変更する乗客を選択してください",
    pleaseselectnewdate: "変更日を選択してください",
    oldtraininfo: "元の列車情報",
    gctrain: "G/C高速鉄道",
    dtrain: "D動車",
    ptrain: "普通",
    traindeptime: "出発時間帯",
    trainarrtime: "到着時間帯",
    trainstart: "始発",
    trainover: "経由",
    hour: "時間",
    minute: "分",
    trainchangeinfo: "変更列車情報",
    changetrain: "列車変更",
    changefee: "変更手数料",
    changeservicefee: "変更サービス料",
    totalfee: "合計",
    changereason: "変更理由",
    checking: "審査待ち",
    boyin: "ボーイング",
    kongke: "エアバス",
    zhuanxiangjia: "専用価格",
    analysis: "旅客分析",
    contact: "連絡先",
    bigcus: "大口顧客",
    airway: "航空会社",
    selectcom: "最初に会社を選択してください",
    nameisetm: "旅客名は必須です",
    writenametype: "正しい名前を入力してください(Chen/Wenjun)",
    baoxianset: "保険設定",
    saleandcus: "販売/カスタマーサービス担当者",
    recommendair: "おすすめフライト",
    more: "もっと見る",
    hide: "非表示",
    triprulename: "出張ポリシー",
    hightsearch: "詳細検索",
    cabinlevel: "座席クラス",
    submitapply: "申請を送信",
    interdemand: "国際線・香港/マカオ/台湾線リクエストフォーム",
    alltotal: "共有",
    demandcus: "ご不明な点がございましたら、カスタマーサービスまでお問い合わせください。関連する問題を迅速に解決いたします。",
    voyageinfos: "フライト情報",
    addvoyage: "フライトを追加",
    passinfos: "乗客情報",
    passnum: "乗客人数",
    sui: "歳",
    twosui: "2歳未満",
    firstairway: "優先航空会社",
    phoneno: "携帯電話番号",
    email: "メールアドレス",
    submit: "提出",
    demandprobtip: "送信に問題がある場合は、こちらにお問い合わせください：",
    normal: "普通",
    student: "学生",
    newimmigrant: "新移民",
    worker: "労務",
    submitordersucc: "注文の送信に成功しました",
    hotelfare: "宿泊料金",
    contservicefee: "サービス料込み",
    hotelinfoimp: "ホテルインポート",
    addhotel: "ホテルを追加",
    inputprice: "正しい金額を入力してください",
    inputpriceerror: "最大金額は最小金額以下にできません",
    starrankdesc: "星評価をおすすめ順に並べ替え",
    starrank: "星評価を高い順に並べ替え",
    starrankasc: "星評価を低い順に並べ替え",
    pricesort: "価格を高い順に並べ替え",
    pricesortdesc: "価格を低い順に並べ替え",
    clickrecomend: "クリックしておすすめ順",
    caclhotelprice: "価格を計算中......",
    none: "なし",
    freebroadbang: "無料ブロードバンド",
    broadband: "有料ブロードバンド",
    freewifi: "無料Wi-Fi",
    wifi: "有料WIFI",
    imgshow: "画像表示",
    additinfos: "追加情報",
    insurinfos: "保険情報",
    surname: "姓",
    givenname: "名",
    orderpassup: "1件の注文あたりの乗客上限は",
    orderpassupend: "人です。それ以上の場合はカスタマーサービスまでご連絡ください！",
    cabintype: "座席クラスタイプ",
    selectcabin: "クラスを選択",
    safetrip: "安心してご旅行を、",
    downloadapp: "力程商旅アプリをダウンロード",
    selectchangepass: "乗客を選択してください！",
    searchpassup: "最大9名様までです！",
    selectcontact: "連絡先を選択",
    cancel: "キャンセル",
    tourindextip: "お客様のビジネストラベルサービスニーズを満たし、ビジネストラベルユーザーに包括的なサービスソリューションを提供することに尽力しています。",
    tourdetailcall: "詳細を問い合わせる",
    yearmeet: "年次総会",
    yearmeettips: "トータルサポートで最高峰の企業年次総会を創出",
    comyearmeet: "会社年次総会",
    comtourtips: "企業のニーズに合わせて最適な旅行行程をカスタマイズ",
    comtour: "社員旅行",
    teambuild: "チームビルディング",
    teambuildtips: "企業向けにパーソナライズされたアウトドアチームビルディングサービスを提供",
    createteambuild: "チームビルディング企画",
    exhibit: "展示会",
    exhibittips: "お客様にワンストップの会議企画・運営サービスを提供",
    comexhibit: "会議・展示会",
    trainordercretips: "1回のご注文につき最大5名様まで追加可能です。それ以上の人数でご旅行の場合は、カスタマーサービスまでお問い合わせいただくか、別途ご注文ください。",
    trainpassrepeat: "乗客名は重複できません。",
    trianorderpassup: "最大5名様まで選択可能です。",
    inputpassgivenname: "乗客名を入力してください。",
    inputpasssurname: "乗客の姓を入力してください。",
    trainpassseattips: "乗客数が選択座席数を超えています",
    aisle: "通路側",
    NeedInvoice: "領収書が必要",
    NoInvoice: "領収書不要",
    delway: "配送方法：",
    exprefee: "配送料：",
    addresspass: "受取人",
    postcode: "郵便番号",
    deladdress: "配送先住所",
    inputphoneno: "携帯電話番号を入力してください",
    inputphonerealno: "正しい携帯電話番号を入力してください",
    inputtickettitle: "請求書の宛名を入力してください",
    inputaddresspass: "受取人を入力してください",
    inputdeladdress: "受取住所を入力してください",
    Invite: "直接受け取り",
    Mail: "メール",
    nothing: "不要",
    parper: "紙の領収書",
    tourservicefee: "旅行サービス料",
    express: "宅配便",
    ticketfare: "券面",
    trainnamecardtips: "氏名、乗車証明書の氏名と一致させてください",
    phonecountry: "中国本土 市外局番 86",
    phoneinfotips: "乗車者の携帯電話番号、SMS認証コードを受信する必要があります",
    savecuspass: "常連旅客として保存",
    triprulemanage: "出張管理",
    trainorderseat: "選択した旅客の座席を選択してください",
    createordernow: "今すぐ予約",
    parenter: "パートナー",
    aboutus: "会社概要",
    companyinfo:
      "力程商旅は中国をリードする出張管理会社であり、力程グループに属しています。10年来、強力なリソース、先進的な技術、質の高いサービス、専門的な管理に支えられ、フォーチュン・グローバル500の120社以上、中国企業トップ500の100社以上を含む、6000社を超える中堅・大企業にサービスを提供しています。",
    companywechat: "力程商旅の公式アカウントをフォロー",
    companyname: "力程商旅",
    simple: "シンプルであればあるほど",
    free: "自由であればあるほど",
    lowermoney: "さらにお得に",
    traintuiinfo: "払い戻し説明",
    traintuiinfo1:
      "1：購入代行が成功し、未発券かつ発車時刻の35分前までであれば、「マイオーダー」から鉄道の注文をクリックし、案内に従って払い戻しを申請できます。発車8日前までの払い戻しについては、鉄道局が各乗車券に対し段階的に払い戻し手数料を徴収します。",
    traintuiinfo2:
      "2：購入代行が成功し、発券済み、または発車時刻の35分前を切っている場合は、お客様ご自身で、乗車券購入時に使用した乗車者の有効な身分証明書原本と鉄道乗車券を携行し、発車前に駅の払い戻し窓口で払い戻し手続きを行ってください。",
    trainchanginfo: "変更説明",
    trainchanginfo1:
      "1：紙の乗車券を未発券で、かつ発車時刻の35分前までであれば、元の乗車券の運賃と同額またはそれ以下の列車に変更できます。その他、オンラインで変更できない場合は、発車前に駅の窓口で手続きを行う必要があります。",
    trainchanginfo2:
      "2：発車48時間前までであれば、予約販売期間内の列車に変更できます。発車48時間前を切っている場合は、乗車券記載の日付の24:00までの任意の列車に変更できます。乗車券記載の日付の翌日以降への変更はできません。",
    trainchanginfo3: "3：新しい乗車券の運賃が元の乗車券より安い場合、差額を返金します。差額分に対しては払い戻し手数料が発生し、現行の払い戻し手数料基準が適用されます。",
    datetimenotrain: "本日の日付の乗車券は未発売です",
    ReserveHint: "現在、非連絡（乗り継ぎ）フライトです。いずれかの区間のフライトに変更が生じた場合、もう一方の区間の払い戻しや変更が必要となった際は、お客様ご自身で相応の払い戻し・変更手数料を負担いただく必要があります。",
    chailvguize: "出張ルール名",
    guonei: "国内",
    guojie: "国際",
    jipiao: "航空券",
    jiudianguize: "ホテル規則",
    huoche: "鉄道",
    guize: "ルール",
    zuidijiajizhun: "最低価格基準",
    wuxianzhi: "無制限",
    xiangduizuidijia: "相対最低価格",
    quantianzuidijia: "終日最低価格",
    shiduanzuidijia: "時間帯最低価格",
    hangbanzuidijia: "フライト最低価格",
    shishihangbanguankong: "リアルタイムフライト管理",
    tiqianyudingshijian: "事前予約時間",
    kedingcangweijibie: "予約可能クラス",
    kedingzuoweijibie: "予約可能座席クラス",
    xieyijipiaoyouxian: "契約航空券優先",
    xieyijiudianyouxian: "契約ホテル優先",
    xiaofeijineshangxian: "利用金額上限",
    dangdizhusubiaozhunshangxian: "現地宿泊料基準上限",
    yudingxuzhi: "予約注意事項",
    dingpiao: "チケット予約",
    tuipiaochongkai: "払い戻し再発行",
    xuanweiqucheng: "往路に選択",
    yes: "はい",
    no: "いいえ",
    firstcity: "1級都市",
    seccity: "2級都市",
    thrcity: "3級都市",
    within: "以内",
    qxzhsrxmdm: "プロジェクトコードを選択または入力してください",
    qxzxmdm: "プロジェクトコードを選択してください",
    weibeixiaofeijineshangxian: "利用金額上限",
    dangdizhusubiaozhun: "現地宿泊料基準",
    youchuang: "窓あり",
    weichuang: "窓なし",
    qianmianfeiquxiao: "前無料キャンセル、",
    zhihoubukequxiao: "以降キャンセル不可",
    wuzao: "朝食なし",
    nights: "合計{number}泊",
  },
  manage: {},
  bill: {
    bankaccount: "銀行口座",
    acronym: "略称",
    select: "選択してください",
    query: "検索",
    added: "追加",
    export: "エクスポート",
    companyname: "会社名",
    inorout: "収支タイプ",
    accountstatus: "口座ステータス",
    operation: "操作",
    enable: "有効",
    disable: "無効",
    update: "修正",
    content: "内容を入力してください",
    cancel: "キャンセル",
    save: "保存",
    confirm: "確定",
    accountadded: "口座追加",
    accountupdate: "口座修正",
    enableordisableprompt: "この操作は無効化または有効化に使用されます、続行しますか？",
    prompt: "ヒント",
    receivebill: "売掛期間",
    bill: "会計期間",
    closeaccountprofit: "決算粗利",
    comparisonsales: "販売数量比較",
    closeaccountstarttime: "決算開始日",
    starttime: "開始日",
    closeaccountendtime: "決算締切日",
    endtime: "締切日",
    clientname: "顧客名",
    customerservicerepresentative: "カスタマーサービス担当者",
    salesrepresentative: "営業担当者",
    number: "件数",
    closeaccountprofittotel: "締め後粗利合計",
    inadditioninterestprofit: "利息控除後粗利",
    receiveprice: "受取金額",
    actualprofit: "実際粗利",
    profitrate: "粗利率",
    interest: "利息",
    additioninterestprofit: "利息後粗利",
    additioninterestprofitrate: "利息後粗利率",
    profitprecent: "粗利構成比",
    back: "<<戻る",
    Internationalflight: "国際航空券",
    internalflight: "国内航空券",
    Internationalhotel: "国際ホテル",
    internalhotel: "国内ホテル",
    internaltrain: "国内列車",
    selectyearmonth: "年月を選択",
    tradebill: "取引支払サイト",
    agreedpaystarttime: "約定決済開始日",
    agreedpayendtime: "約定決済終了日",
    billdate: "請求日",
    billdateend: "締切日",
    agreedpaydate: "約定決済日",
    waitoutday: "未請求",
    waitaudited: "未審査",
    waitconfirm: "未確認",
    amountshouldbeclosed: "決済予定金額",
    detail: "詳細",
    total: "合計",
    createtime: "作成日",
    orderid: "注文番号",
    businesstype: "業務タイプ",
    servicetype: "サービスタイプ",
    paymentincludinginsurancecharge: "支払額(サービス/保険料含む)",
    passengername: "旅客名",
    bookingname: "予約者",
    productname: "製品名",
    billaggregate: "支払期間サマリー",
    billdetail: "支払期間明細",
    size: "サイズ",
    amountreceivable: "未収金額",
    allstatus: "すべてのステータス",
    billname: "支払期間名",
    expiretime: "期日",
    overdueday: "延滞(日数)",
    receivable: "売掛金",
    havebeentaken: "入金済",
    notreceive: "未収",
    profit: "粗利",
    totalaccountingperiod: "支払期間外総額",
    invoicestatus: "請求書ステータス",
    statusdetail: "ステータス(明細数)",
    Updates: "更新",
    receivedetail: "売掛金明細",
    createstarttime: "作成開始日",
    createendtime: "作成終了日",
    receivestarttime: "入金開始日",
    receiveendtime: "入金終了日",
    paymentstarttime: "支払開始日",
    paymentendtime: "支払終了日",
    applyarea: "エリアタイプ",
    supplyid: "供給伝票番号",
    supplyname: "供給名",
    voucherno: "証憑番号",
    intentname: "出張目的",
    projectcode: "プロジェクトコード",
    invoiceid: "請求書番号",
    template: "テンプレート",
    templatemanager: "テンプレート管理",
    fullscreen: "全画面表示",
    quanping: "全画面終了",
    orderselect: "注文チェック",
    receivestatus: "入金ステータス",
    invoiceapplication: "請求書申請",
    receiveaudit: "入金審査",
    receiveconfirm: "入金確認",
    losstreatment: "欠損処理",
    receivefinished: "入金締め",
    receiveaudited: "入金返戻",
    costcenter: "コストセンター",
    expenseDepartment: "費用負担部門",
    supplyName: "供給名",
    bulkEditingSupplyName: "供給名称の一括変更",
    all: "全て",
    paymentstatus: "支払状況",
    obligation: "支払待ち",
    paymentaudit: "支払審査",
    paymentconfirm: "支払確認",
    paymentfinished: "入金締め",
    paymentaudited: "入金返戻",
    orderselecttext: "チェックを入れる注文番号を入力してください（スペース、改行、またはカンマで区切ってください）",
    receivefaila: "この操作を行う前に、まず顧客検索を行ってください",
    receivefailb: "操作する明細にチェックを入れてください",
    receivefailc: "正しいデータを選択してください",
    receivefaild: "最初に供給名称をプリセットしてください",
    invoiceapplyfaila: "請求書申請が未提出のデータを選択してください",
    order: "注文",
    losstreatmentfail: "。締め処理の粗利率が10%を超えるか、10%を下回る場合は、まず欠損処理を行ってください。",
    loading: "操作を実行中です......",
    orderselectfail: "明細にチェックを入れる注文番号を入力してください",
    tradedetail: "取引明細",
    templatename: "テンプレート名",
    rightmove: "右へ移動",
    leftmove: "左へ移動",
    topmove: "上へ移動",
    bottommove: "下へ移動",
    rightfaila: "右に移動するデータを選択してください",
    leftfaila: "左に移動するデータを選択してください",
    topfaila: "このデータは上に移動できません",
    bottomfaila: "このデータは下に移動できません",
    templatfaila: "上下に移動するデータを1つ選択してください",
    costcenternamesearch: "コスト名検索",
    expenseDepartmentNameSearch: "費用負担部門名検索",
    supplyNamesearch: "供給名検索",
    billnamesearch: "会計期間名検索",
    receivetablefaila: "コストセンターを選択してください",
    selectExpenseDepartment: "費用負担部門を選択してください",
    receivetablefailb: "先に終了してから再編集してください",
    receivetablefailc: "会計期間を選択してください",
    receivetablefaild: "供給名を選択してください",
    profitandlossreasons: "損益原因",
    lossreasons: "損失原因",
    profitreasons: "利益原因",
    reakeven: "損失なし",
    losscausefaila: "損失原因を選択してください",
    invoiceitemname: "プロジェクト名",
    invoiceitemmodel: "規格型番",
    invoiceitemunitname: "単位",
    invoiceitemnum: "数量",
    invoiceitemfare: "単価",
    invoiceitemcost: "原価",
    invoiceitemamount: "金額",
    invoiceitemrate: "税率",
    invoiceitemtax: "税額",
    delete: "削除",
    invoicetitle: "請求書の宛名",
    invoicetype: "請求書の種類",
    clientadress: "顧客住所",
    clientemail: "顧客メールアドレス",
    remark: "備考",
    invoiceapplyfailb: "正しい単価を入力してください",
    invoiceapplyfailc: "正しい税率を入力してください",
    invoiceapplyfaild: "提出する請求書の金額は元の請求書の金額を超えることはできません",
    invoiceapplyfaile: "請求書の申請が成功しました",
    accountname: "口座名義",
    accounttype: "口座タイプ",
    tradeaccountlistfaila: "正しい金額を入力してください",
    tradeaccountlistfailb: "チャージ登録が成功しました",
    tradeaccountlist: "口座一覧",
    availablebalance: "利用可能残高",
    accountbalance: "口座残高",
    creditbalance: "与信限度額",
    blockedamount: "凍結金額",
    flow: "取引明細",
    recharge: "チャージ",
    blockedtransactions: "取引凍結",
    tradename: "取引名",
    freezingtime: "凍結時間",
    creditline: "与信限度額",
    contractdate: "契約日",
    creditaddedprompt: "固定与信限度額の有効期限は契約日を基準とします。期限切れの場合は更新してください。",
    provisionalcredit: "臨時与信",
    effectivedate: "発効日",
    expirydate: "失効日",
    lodamt: "チャージ金額",
    transactionflowing: "取引明細",
    tradedate: "取引日",
    flowtype: "明細タイプ",
    transactionamount: "取引金額",
  },
  webdata: {
    interfaceManage: "構成管理",
    ChangeCheckPNR: "コード検証",
    insuranceamend: "返金処理",
    orderlist: "注文リスト",
    mallservice: "モールサービス",
    wechat: "WeChat管理",
    dealwarranty: "保険証券処理",
    insuranceorder: "保険注文",
    insuranceservice: "保険サービス",
    insurancepolicy: "保険政策",
    changruletime: "変更期限",
    baggagerule: "手荷物許容量ルール",
    departmanage: "部門管理",
    see: "閲覧",
    oftenconsumermanage: "常連客管理",
    oftenconsumer: "よく利用する旅客",
    costcenter: "コストセンター",
    expenseDepartment: "費用負担部門",
    deal: "処理",
    waitdispos: "処理待ち",
    waitdispose: "処理待ち",
    waitpayment: "支払待ち",
    waitconfirm: "確認待ち",
    waitthrowin: "審査待ち",
    waitapprove: "承認待ち",
    waitsubmit: "提出待ち",
    waitrefund: "返金待ち",
    waitbooking: "予約待ち",
    addressmanage: "住所管理",
    dealorder: "注文処理",
    ordermanage: "注文管理",
    subservice: "サブスクリプションサービス",
    dealinvoice: "請求書処理",
    inviceservice: "請求書サービス",
    invoicemanage: "請求書管理",
    servicefeesetting: "サービス料設定",
    servicemanage: "サービス管理",
    serviceinfo: "サービス情報",
    interfaceinfo: "インターフェース設定",
    payment: "支払い",
    dealpayment: "支払い処理",
    peoplemanage: "個人管理",
    companysetting: "会社設定",
    internationflight: "国際航空券",
    internationhotel: "国際ホテル",
    internationaltour: "海外旅行",
    chinatraffic: "国内送迎",
    chinatrain: "国内列車",
    chinaflight: "国内航空券",
    chinahotel: "国内ホテル",
    chinatravel: "国内旅行",
    trainorder: "鉄道注文",
    flightorder: "航空券注文",
    trafficorder: "注文処理",
    basedata: "基本データ",
    transaction: "取引明細",
    tradereceive: "売掛金明細",
    tradepayment: "取引明細",
    smstemplate: "SMSテンプレート",
    datastatistics: "データ統計",
    tradeweek: "取引支払サイト",
    billreceive: "売掛期間",
    billpayment: "取引支払サイト",
    hotelorder: "ホテル注文",
    customermanage: "顧客管理",
    customerlevel: "顧客レベル",
    dealdelivery: "宅配便処理",
    deliveryservice: "宅配便サービス",
    deliverypolicy: "宅配便ポリシー",
    flowmanage: "プロセス管理",
    tourorder: "旅行注文",
    companymanage: "企業管理",
    companyinfo: "企業情報",
    companyhome: "企業ホームページ",
    visaorder: "ビザ注文",
    visaservice: "ビザサービス",
    allorder: "すべての注文",
    purviewmanage: "権限管理",
    purviewcontrol: "権限制御",
    approve: "承認",
    dealmoneyin: "入金処理",
    moneynandoutmanage: "収支管理",
    authorizemanage: "認可管理",
    amendorder: "変更・キャンセル注文",
    changeamendrule: "払戻・変更規則",
    clientuser: "大口顧客",
    domainmanage: "ドメイン管理",
    notifymanage: "通知管理",
    dealrefund: "返金処理",
    dealamend: "払い戻し処理",
    dealamendorder: "払い戻し処理",
    dealamendtour: "ツアーキャンセル処理",
    webmanage: "ウェブサイト管理",
    mineinfo: "マイ情報",
    usermain: "マイページ",
    systemmanage: "システム管理",
    discrete: "分割済み",
    forbiddened: "無効化済み",
    canceled: "キャンセル済み",
    throwined: "公開済み",
    rejected: "返却済み",
    rejectes: "返却済み",
    finished: "完了済み",
    finishes: "完了済み",
    hanguped: "非公開済み",
    bankaccount: "銀行口座",
    coupon: "クーポン",
    employeemanage: "従業員管理",
    cannnot: "一時不可",
    cannot: "一時不可",
    accountsafe: "構成管理",
    accountmanage: "アカウント管理",
    tradeaccount: "企業アカウント",
    financemanage: "会計管理",
    policymanage: "ポリシー管理",
    policymangage: "ポリシー管理",
    jobmanage: "役職管理",
    businessservice: "ビジネストラベルサービス",
    chargeservice: "付加価値サービス",
    chargepolicy: "サービス方針",
    feedback: "フィードバック",
    mallservice: "モールサービス",
    orderlist: "注文リスト",
    sharelist: "イベント管理",
    orderchange: "フライト変更一覧",
    smsnotify: "通知一覧",
    supplylist: "供給管理",
  },
  category: {
    AmendingFlight: "一部払い戻し中",
    ChangeingFlight: "一部変更中",
    AmendingTrain: "一部払い戻し中",
    ChangeingTrain: "一部変更中",
    AmendingHotel: "一部キャンセル中",
    ChangeingHotel: "一部変更中",
    AmendingTour: "一部ツアーキャンセル中",
    ChangeingTour: "一部変更中",
    AmendedFlight: "一部払い戻し",
    ChangeedFlight: "一部変更",
    AmendedTrain: "一部払い戻し",
    ChangeedTrain: "一部変更",
    AmendedHotel: "一部キャンセル",
    ChangeedHotel: "一部変更",
    AmendedTour: "一部ツアーキャンセル",
    ChangeedTour: "一部変更",
    AllAmendingFlight: "払い戻し中",
    AllChangeingFlight: "変更中",
    AllBookingFlight: "購入中",
    AllAmendingTrain: "払い戻し中",
    AllChangeingTrain: "変更中",
    AllBookingTrain: "購入中",
    AllAmendingHotel: "キャンセル中",
    AllChangeingHotel: "変更中",
    AllBookingHotel: "予約中",
    AllAmendingTour: "ツアーキャンセル中",
    AllChangeingTour: "変更中",
    AllBookingTour: "予約中",
    AllAmendedFlight: "払い戻し成功",
    AllChangeedFlight: "変更成功",
    AllBookedFlight: "購入成功",
    AllAmendedTrain: "払い戻し成功",
    AllChangeedTrain: "変更成功",
    AllBookedTrain: "購入成功",
    AllAmendedHotel: "チェックアウト成功",
    AllChangeedHotel: "変更成功",
    AllBookedHotel: "予約成功",
    AllAmendedTour: "ツアーキャンセル成功",
    AllChangeedTour: "変更成功",
    AllBookedTour: "予約成功",
    "1672category": "ホテル料金",
    "1674category": "ツアー料金",
    "1660category": "券面金額",
    "1662category": "空港施設料",
    "1664category": "燃料費",
    "1666category": "税費",
    "1692category": "直接割引",
    "1668category": "保険料",
    "1670category": "サービス料",
    "1678category": "返金",
    "1682category": "変更",
    "1684category": "元価",
    "1690category": "その他",
    "1694category": "割引",
    Conference: "会議",
    EnterprisesUnit: "企業・事業体",
    GovernmentDepartment: "政府機関",
    PeopleEnterprises: "民間資産",
    CountryCapital: "国有資産",
    ChinaOuterJoinCapital: "中外合弁",
    ForeignCompany: "外資独資",
    CompanySize100: "100人以下",
    CompanySize499: "100～499",
    CompanySize999: "500～999",
    CompanySize4999: "1000～4999",
    CompanySize5kUp: "5000以上",
    Internal: "国内",
    Overseas: "国際",
    IDCard: "身分証明書",
    PassportCard: "パスポート",
    StudentCard: "学生証",
    OfficerCard: "軍人証",
    OtherCard: "その他",
    Residencepermit: "香港・マカオ・台湾居民居住証",
    ForeignResidentIDCard: "外国人永久居留身分証",
    HKCompatriotsyndrome: "香港・マカオ通行証",
    TaiCompatriotsyndrome: "台湾通行証",
    Enable: "有効",
    UnEnable: "無効",
    Male: "男性",
    Female: "女性",
    Yes: "はい",
    No: "いいえ",
    SingleVoyage: "片道",
    RoundVoyage: "往復",
    ReturnVoyage: "復路",
    MultiVoyage: "複数回",
    TransferVoyage: "乗り継ぎ",
    BSP: "BSP",
    B2B: "B2B",
    OverseasElectronic: "海外電子",
    ConnectVoyage: "連絡便",
    Team: "団体",
    Fit: "個人客",
    Unlimited: "制限なし",
    HighOpen: "高開",
    DownOpen: "低開",
    Monday: "月曜日",
    Tuesday: "火曜日",
    Wednesday: "水曜日",
    Thursday: "木曜日",
    Friday: "金曜日",
    Saturday: "土曜日",
    Sunday: "日曜日",
    WithinIntercontinental: "同一大陸内",
    PolicyDepartAirport: "ポリシー出発空港範囲",
    NoReward: "報酬なし",
    AgencyFreeFee: "代理店手数料なし",
    MustBackAirport: "旅程出発空港に戻る必要あり",
    AppointBackAirport: "指定帰国国または空港範囲",
    CommonFlight: "普通便",
    ShareFlight: "コードシェア便",
    Prepay: "前払い",
    CashPay: "現払い",
    OverseasStudent: "留学生",
    Immigrant: "移民",
    Worker: "労働者",
    Seaman: "船員",
    Youth: "青年",
    HkMacaoTw: "香港・マカオ・台湾",
    ForeignNationality: "外国籍",
    NotChineseName: "非漢字氏名",
    AddOn: "Add-On",
    OldGge: "高齢者",
    OverseasTransfer: "海外経由",
    NotchRange: "ギャップ旅程",
    OPEN: "OPEN",
    SPA: "SPA",
    QValue: "Q値",
    SharedFlight: "コードシェア便",
    ThreeAgreement: "三者間協定",
    Package: "セット券",
    WholeGroup: "団体全体",
    SmallGroup: "小団体",
    RewardsAdults: "報酬は大人と同じ",
    NoOpenBonus: "報酬なしでも可",
    WithoutReward: "報酬ありでも可",
    NotOpen: "不可",
    NoCodingRequired: "コード返却不要",
    CodeOut: "コード変更して発券",
    BigTicket: "大口コード発券（コード変更不要）",
    BigNoTicket: "大口コード発券（コード変更必要）",
    NoChange: "空席なし変更不可発券（外部に空席がある場合コード変更）",
    SingleRound: "片道/往復",
    MonthCycle: "月",
    WeekCycle: "週",
    DayCycle: "日",
    HKMpermit: "帰郷証",
    TaiWpermit: "台湾同胞証",
    OnlineServiceMode: "オンラインサービス",
    LineServiceMode: "オフラインサービス",
    PercentageMode: "パーセンテージ",
    FixedPrice: "固定金額",
    ExpensePrice: "券面額",
    PriceFareAndTax: "券面額+税金",
    DirectUpdate: "直接修正",
    AddLittle: "ポイント加算",
    ReduceLittle: "ポイント減算",
    User: "ユーザー",
    Jobs: "職位",
    Group: "グループ",
    Department: "自部門",
    Company: "会社",
    Service: "サービス",
    Customer: "カスタマーサービス",
    Actions: "権限",
    CostCenter: "コストセンター",
    ExpenseDepartment: "費用負担部門",
    Server: "サーバーサイド",
    Client: "クライアントサイド",
    Normal: "正常",
    Change: "変更",
    SelfOnly: "自分のみ",
    SelfLower: "自分と配下",
    NoLimit: "制限なし",
    UnAuthorized: "未認証",
    Authorized: "認証済み",
    SystemRole: "システムロール",
    UserRole: "ユーザーロール",
    ContinueBefore: "続行前",
    ContinueAfter: "続行後",
    ReturnBefore: "戻る前",
    ReturnAfter: "戻った後",
    ChangeBefore: "変更前",
    ChangeAfter: "変更後",
    NeedInvoice: "領収書が必要",
    NoInvoice: "領収書不要",
    WEB: "ウェブサイト",
    RMB: "元",
    Dollar: "米ドル",
    Alipay: "アリペイ",
    WeChat: "微信",
    Cash: "現金",
    Monthly: "月次決済",
    Tour: "旅行",
    Hotel: "ホテル",
    Flight: "航空券",
    AdviceNote: "出発通知書",
    GuestEnclosure: "ゲスト添付ファイル",
    other: "その他",
    Electronic: "電子領収書",
    ClientMessage: "ゲストへのメッセージ",
    SupplyMessage: "サプライヤーへのメッセージ",
    WorkmateMessage: "同僚へのメッセージ",
    Traveled: "旅行済み",
    NotTravel: "未旅行",
    Change: "変更",
    Sales: "販売",
    Refund: "返金",
    PasswordVerify: "ログインパスワード",
    EmailVerify: "メール認証",
    PhoneVerify: "携帯電話認証",
    NameVerify: "実名認証",
    SafetyProblem: "セキュリティ質問",
    APP: "携帯電話",
    BtripService: "ビジネストラベルサービス",
    HotelService: "ホテルサービス",
    TourService: "旅行サービス",
    FlightService: "航空券サービス",
    ChargeService: "付加価値サービス",
    HightDirector: "高校の担任の先生は誰ですか",
    Firstgame: "初めてクリアしたゲーム",
    PhoneContact: "携帯電話",
    TelephoneContact: "電話",
    EmailContact: "メールアドレス",
    QQ: "QQ",
    OnlineKnow: "オンライン予約注意事項",
    TourKnow: "国内旅行予約注意事項",
    Enable: "有効",
    UnEnable: "無効",
    PriceEnable: "価格有効化",
    PriceUnEnable: "価格無効化",
    Indeterminate: "価格未定",
    PrivatePolicy: "プライベートポリシー",
    PublicPolicy: "パブリックポリシー",
    Receive: "入金",
    Payment: "支払い",
    Unsubmit: "未提出",
    Submited: "提出済み",
    Unaudit: "未承認",
    Audited: "承認済み",
    AuditRefuse: "承認拒否",
    Untreated: "未処理",
    RefundeBad: "退団失敗",
    RefundeIng: "退団処理中",
    Refunded: "ツアーキャンセル成功",
    Country: "国",
    Scenic: "景勝地",
    City: "都市",
    Province: "省",
    Area: "エリア",
    Airport: "空港",
    Continent: "州",
    District: "区",
    Invite: "直接受け取り",
    Mail: "メール",
    insideOutside: "国内出発",
    outsideInside: "直行SOTO区間",
    insideInsideOutside: "国内出発アドオン",
    outsideInsideInside: "海外出発アドオン",
    outsideOutside: "海外から海外",
    insideOutsideOutside: "国内出発経由",
    outsideOutsideInside: "海外出発経由",
    outsideOutsideOutside: "海外海外海外",
    outsideInsideOutside: "海外国内海外",
    globalGlobal: "グローバルからグローバル",
    globalGlobalGlobal: "グローバル中継グローバル",
    openAgencyFee: "代理手数料なしで開設可能",
    NoWay: "開設不可",
    InsuranceService: "保険サービス",
    ExpressService: "宅配便サービス",
    InvoiceService: "請求書サービス",
    VisaService: "ビザサービス",
    TrainService: "鉄道サービス",
    TravelNotes: "予約注意事項",
    ExpenseKnowledge: "費用に関する注意事項",
    ShortMessage: "SMS",
    Mail: "郵便",
    Wechat: "微信",
    EexamineOrderSms: "承認依頼メッセージ内容",
    EexamineApprovalSms: "承認完了メッセージ内容",
    EexamineRefuseSms: "承認拒否メッセージ内容",
    EexamineAccomplishSms: "注文処理完了メッセージ内容",
    Refunds: "返金完了",
    Transfer: "振込",
    Train: "鉄道チケット",
    BusinessSeat: "ビジネス席",
    SpecialSeat: "特等席",
    Level1Seat: "一等席",
    Level2Seat: "二等席",
    HighGradeSleeper: "高級軟臥",
    CommonSleeper: "軟臥",
    HardSleeper: "硬臥",
    SoftSeat: "軟座",
    HardSeat: "硬座",
    NotHaveSeat: "立席",
    Economy: "エコノミークラス",
    Buissenes: "ファーストクラス",
    First: "ファーストクラス",
    DayLowestPrice: "終日最低価格",
    FlightLowestPrice: "全便最安値",
    HighSpeedRail: "高速鉄道",
    SleepingBerth: "寝台",
    Other: "その他",
    Whole: "全て",
    Position: "役職",
    Department: "部署",
    FlatFeeCharges: "固定料金で請求",
    PercentageCostFee: "パーセンテージで請求",
    Department: "自部署",
    DepartmentLower: "本部門及び下位組織",
    TravelPurpose: "出張目的",
    PolicyCause: "違反理由",
    FlightChange: "旅程を変更したいので、飛行機に乗りたくありません",
    FlightMistaken: "旅程、日付、時間、名前を間違えました",
    FlightDelay: "フライトの遅延または欠航",
    OnBusiness: "公用",
    OnPersonal: "私用",
    PayApproval: "注文支払い承認",
    ChangeApproval: "注文変更承認",
    ReturnTicketApproval: "注文払い戻し承認",
    People: "個人",
    legs: "区間別課金",
    OnLineReservation: "オンライン予約",
    OffLineReservation: "オフライン予約",
    WorkingTime: "勤務時間",
    NonWorkingTime: "営業時間外",
    OnlineBookingApproval: "オンライン予約は承認が必要",
    OfflineBookingApproval: "オフライン予約は承認が必要",
    ViolateRuleApproval: "ルール違反は承認が必要",
    ChangeTripApproval: "旅程変更は承認が必要",
    CancelTripApproval: "旅程キャンセルは承認が必要",
    Preflight: "出発前",
    AfterTakeoff: "出発後",
    RuleEndorse: "変更",
    RuleFund: "払い戻し",
    Reserve: "予約",
    CaterService: "飲食サービス",
    TrafficService: "交通サービス",
    TicketService: "入場券サービス",
    BaseService: "基本サービス",
    Volunteer: "任意",
    FlightChang: "フライト変更",
    BuyAgain: "再購入",
    SickAmend: "病気による払い戻し",
    NameError: "名前が間違っています",
    CabinChange: "アップグレード交換",
    TicketInvalid: "払い戻し",
    Other: "その他",
    WaitSubmit: "提出待ち",
    WaitPayment: "支払い待ち",
    WaitConfirm: "確認待ち",
    Finished: "完了済み",
    Canceled: "キャンセル済み",
    Rejected: "返却済み",
    SystemService: "システムサービス",
    WorkService: "業務サービス",
    OrderService: "注文サービス",
    BillService: "請求書サービス",
    UserService: "個人サービス",
    CompanyService: "法人サービス",
    TicketFare: "券面",
    BuildFare: "空港使用料",
    FuelFare: "燃油サーチャージ",
    TaxFare: "税金・手数料",
    SafeFare: "保険",
    ServiceFare: "サービス",
    HotelFare: "宿泊料金",
    TeamFare: "ツアー代金",
    AmendFare: "払い戻し",
    ChangeFare: "変更",
    OtherFare: "その他",
    DirectReduction: "直接割引",
    ThrowDiscount: "割引",
    Infant: "幼児",
    Enfant: "子供",
    Young: "大人",
    Wrinkly: "中年",
    Elderly: "高齢者",
    BusinessLicence: "営業許可証",
    TaxRegistration: "税務登記証",
    Other: "その他",
    WaitSubmit: "提出待ち",
    WaitDispose: "処理待ち",
    Cannot: "一時不可",
    Finished: "完了済み",
    Rejected: "拒否済み",
    Bill: "会計",
    Balance: "残高",
    Credit: "クレジット",
    Integral: "ポイント",
    FixedCredit: "固定与信",
    InterimCredit: "臨時与信",
    WaitOutDay: "出金待ち",
    WaitAudited: "審査待ち",
    WaitConfirm: "確認待ち",
    WaitReceive: "入金待ち",
    Finished: "決算済み",
    Rejected: "返却済み",
    Change: "変更",
    Bill: "財務",
    Company: "会社",
    Product: "商品",
    Sales: "販売",
    Amend: "返金",
    People: "個人",
    Customer: "顧客",
    HotelChange: "旅程変更",
    Station: "駅",
    CompanyID: "会社",
    People: "個人",
    SpecialTicket: "専用請求書",
    GeneralTicket: "普通請求書",
    Electronic: "電子請求書",
    Paper: "紙の領収書",
    HotelDelay: "旅程キャンセル",
    Economy5: "5割引エコノミークラス",
    Economy6: "6割引エコノミークラス",
    Economy7: "7割引エコノミークラス",
    Economy8: "8割引エコノミークラス",
    Economy9: "9割引エコノミークラス",
    MessageNotify: "SMS通知",
    MailNotify: "メール通知",
    WechatNotify: "WeChat通知",
    AppNotify: "アプリ通知",
    WaitOutDay: "計上待ち",
    OverdueNo: "期限前",
    OverdueYes: "期限切れ",
    Percentage: "パーセンテージ",
    FixMoney: "固定金額",
    RemovePrice: "価格除外",
    Creater: "作成者",
    Member: "参加者",
    Watcher: "フォロワー",
    Text: "テキスト",
    Html: "HTML",
    Link: "リンク",
    Plugin: "プラグイン",
    CompanyInternal: "社内",
    CurrentDomainName: "現在のドメイン",
    AllDomainName: "すべてのドメイン",
    Email: "メール",
    OrdinaryAddress: "一般アドレス",
    B2C: "B2C",
    B2G: "B2G",
    Demand: "要件",
    WaitBooking: "予約待ち",
    WaitApprove: "承認待ち",
    WaitConfirm: "確認待ち",
    WaitPayment: "支払い待ち",
    WaitDispose: "処理待ち",
    Finished: "完了済み",
    Canceled: "キャンセル済み",
    Rejected: "返却済み",
    Discrete: "分割済み",
    Cannot: "一時不可",
    EmailAuth: "メールアカウント",
    MobileAuth: "携帯電話アカウント",
    AccountAuth: "ユーザーアカウント",
    WeixinAuth: "WeChat認証",
    DynamicAuth: "動的検証",
    BookingInfo: "予約注意事項",
    PolicyCause: "違反理由",
    TravelPurpose: "出張目的",
    WaitRefund: "返金待ち",
  },
};



// WEBPACK FOOTER //
// ./src/lang/JP.js